import React from 'react';
import {Modal, Typography, Button, Radio, Input} from 'antd';
import {CloseIconDialog} from 'Components';
import {useCSContext} from 'Context/ContentStackContext';
import {REFILL_REASONS} from 'Utils/constants/genericConstants';

const {Title} = Typography;

const RefulfillDialog = (props) => {
  const {visible, onModalClose} = props;
  const {artifacts} = useCSContext();

  return (
    <Modal open={visible} onCancel={onModalClose} footer={null} closable={false}>
      <CloseIconDialog callback={onModalClose} image={artifacts.cross_icon} />
      <Title level={3} style={{paddingTop: 32, marginBottom: 0}}>
        Re-Fulfill Order
      </Title>
      <Title level={4} style={{marginTop: 8}}>
        Reason for Re-fulfill
      </Title>

      {/* checkedState/onModalSelectChange are driven per-index by the caller
          (not a single controlled value), so this stays individual Radios
          rather than a Radio.Group, matching the original's behavior exactly. */}
      <div style={{display: 'grid', gridTemplateColumns: '1fr 1fr'}}>
        {REFILL_REASONS.map((key, index) => (
          <Radio
            key={key}
            onChange={() => props.onModalSelectChange(index)}
            checked={props.checkedState[index]}>
            {key}
          </Radio>
        ))}
      </div>

      <Input.TextArea
        placeholder="Add Comments"
        rows={3}
        style={{marginTop: 10}}
        onChange={(e) => props.onModalTextChange(e)}
      />
      <Button type="primary" onClick={props.onSubmitModal} style={{marginTop: 20}}>
        Submit Re-fulfillment Order
      </Button>
    </Modal>
  );
};

export default RefulfillDialog;
